import { useState } from 'react';
import {
  Box,
  Typography,
} from '@mui/material';

import { useTranslation } from 'react-i18next';
import { namespaces } from '../../../../../../../../../i18n/i18n.constants';

import { ObjectType } from '../../../../../../../../../types/objectType';

import { detailBoxShowMoreStyle } from './detailBoxShowMoreStyle';

export const DetailBoxShowMore = (
  {
    title,
    value,
    maxLengthTextShowed,
  }: ObjectType,
) => {
  const { t } = useTranslation(namespaces.pages.resumesSearch);
  const TRADUCTION_BASE_PATH = 'detailedInfoModal.';
  const showMoreText = t(`${TRADUCTION_BASE_PATH}showMore`);
  const showLessText = t(`${TRADUCTION_BASE_PATH}showLess`);
  const currentValue = typeof value === 'string' ? value : '';
  const [expandedValue, setExpandedValue] = useState<string | null>(null);
  const hasMore = currentValue.length > maxLengthTextShowed;
  const isExpanded = expandedValue === currentValue;
  const textToShow = hasMore && !isExpanded
    ? `${currentValue.slice(0, maxLengthTextShowed)}...`
    : currentValue;

  const { sx } = detailBoxShowMoreStyle;
  return (
    <>
      <Box
        sx={sx.container}
      >
        <Typography
          variant='body2'
          color="text.secondary"
          gutterBottom
          sx={sx.title}
        >
          {title}
        </Typography>
        <Box
          sx={sx.descriptionContainer}
        >
          <Typography
            variant='body2'
            ml={2}
            gutterBottom
            dangerouslySetInnerHTML={{ __html: textToShow }}
          />
          {hasMore && (
            <Box
              sx={sx.showMoreContainer}
            >
              <Typography
                variant='body2'
                gutterBottom
                onClick={() => setExpandedValue(isExpanded ? null : currentValue)}
                sx={sx.showMore}
              >
                {isExpanded ? showLessText : showMoreText}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};
